import React from "react";
import BusinessLandingPage from "../../../platform/pages/business/businessPage/businessLandingPage";

export default function BookingStartPublicPage(): JSX.Element {
  return <BusinessLandingPage />;
}
